// Точка монтирования приложения. Грузится из main.tsx ДИНАМИЧЕСКИ и только
// после initI18n(): App и всё, что он импортирует, вычисляют подписи на уровне
// модуля (`i18n.t()` в списках вкладок, названиях тиров), а словари теперь
// приезжают отдельным запросом. Статический импорт App в main.tsx выполнил бы
// эти модули раньше словарей — и на экране остались бы коды ключей.
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'

export function mount(): void {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
}
